import { useCallback, useEffect, useState } from 'react'

export default function useWindowSize() {
  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)

  const getWindowDimensions = useCallback(() => {
    setWidth(window.innerWidth)
    setHeight(window.innerHeight)
  }, [])

  useEffect(() => {
    getWindowDimensions()
    window.addEventListener('resize', getWindowDimensions)
    return () => window.removeEventListener('resize', getWindowDimensions)
  }, [])

  return {
    width,
    height,
  }
}
